export const LOGIN_LOGOUT_SUCCESS = 'LOGIN_LOGOUT_SUCCESS';
export const SET_ADMIN_MODE = 'SET_ADMIN_MODE';
export const SET_DIVISION_ID = 'SET_DIVISION_ID';
export const SET_MENU_ID = 'SET_MENU_ID';
